<template>
  <div class="exam-detail" ref="examDetail">
    <div
      class="quizze"
      v-for="(exercise, index) in cloneResults"
      :key="index"
      :index="index"
      ref="exam">
      <div class="title">
        <div class="tag">
          <span>{{index + 1}}</span>
        </div>
        <span v-if="exercise.userAnswer === null" class="no-data">（未作答）</span>
        <van-speaker :id="index" class="primary" v-if="exercise.audio" :src="exercise.audio" />
      </div>
      <component
        :is="quizzes[exercise.code]"
        :is-exam="true"
        :auto-play="false"
        :mode="exercise.mode"
        :exercise="exercise"
        :is-done="true"
        :is-show-explain="true"
        :index="index"
        :user-answer="cloneResults[index].userAnswer">
      </component>
    </div>
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';
import TYLJ from 'vanthink-components/components/quiz/TYLJ.vue';
import JXZH from 'vanthink-components/components/quiz/JXZH.vue';
import KY from 'vanthink-components/components/quiz/KY.vue';
import DX from 'vanthink-components/components/quiz/DX.vue';
import QHLJ from 'vanthink-components/components/quiz/QHLJ.vue';
import MED from 'vanthink-components/components/quiz/MED.vue';
import BQWZ from 'vanthink-components/components/quiz/BQWZ.vue';
import WK from 'vanthink-components/components/quiz/WK.vue';
import CHXZ from 'vanthink-components/components/quiz/CHXZ.vue';
import DCTX from 'vanthink-components/components/quiz/DCTX.vue';
import SK from 'vanthink-components/components/quiz/SK.vue';
import HYDC from 'vanthink-components/components/quiz/HYDC.vue';
import DCPX from 'vanthink-components/components/quiz/DCPX.vue';
import THXZ from 'vanthink-components/components/quiz/THXZ.vue';
import YDLJ from 'vanthink-components/components/quiz/YDLJ.vue';
import XCTK from 'vanthink-components/components/quiz/XCTK.vue';
import WXTK from 'vanthink-components/components/quiz/WXTK.vue';
import VanSpeaker from 'vanthink-components/components/common/Speaker.vue';
import AudioPlayer from '@/services/audio-player';
import utils from '@/services/utils';

export default {
  props: {
    results: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    VanSpeaker,
  },
  data() {
    return {
      quizzes: {
        QHLJ,
        KY,
        DX,
        TYLJ,
        JXZH,
        MED,
        BQWZ,
        WK,
        CHXZ,
        DCTX,
        SK,
        HYDC,
        DCPX,
        THXZ,
        YDLJ,
        XCTK,
        WXTK,
      },
      cloneResults: [],
    };
  },
  created() {
    this.cloneResults = utils.clone(this.results);
  },
  methods: {
    setAnchor(index, { autoPlay = true }) {
      const el = this.$refs.exam[index];
      this.$refs.examDetail.scrollTop = el ? el.offsetTop : 0;
      if (this.cloneResults[index].audio && autoPlay) {
        AudioPlayer.stopAll();
        AudioPlayer.play(this.cloneResults[index].audio);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .exam-detail {
    height: calc(100% - 65px);
    overflow-y: scroll;
    .title {
      margin-top: 25px;
      /deep/ .speaker {
        margin-left: 5px;
      }
      .tag {
        position: relative;
        left: 0;
        display: inline-block;
        width: 50px;
        height: 30px;
        border-radius: 0 14px 14px 0;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        color: #fff;
        background-color: $primary;
      }
      .no-data {
        font-size: 24px;
        vertical-align: middle;
        color: $danger;
      }
    }
    .quizze {
      border-bottom: 1px solid #ececec;
    }
    /deep/ .hydc-container {
      padding: 30px 30px;
    }
    /deep/ .dcpx-container {
      padding-bottom: 20px;
      .explain {
        margin-top: 30px!important;
      }
      .main {
        margin: 0 auto 0;
      }
    }
    /deep/ .dctx-container {
      padding: 10px 0;
      .main {
        margin-top: 0!important;
        .text-input {
          margin-top: 0!important;
        }
        .explain {
          margin-top: 30px;
        }
        .text {
          margin-top: 0!important;
        }
      }
    }
    /deep/ .chxz-container {
      margin-bottom: 20px;
      .title {
        margin-top: 0px!important;
      }
    }
    /deep/ .ydlj-container, .wxtk-container {
      height: 600px;
    }
  }
</style>
